<script lang="ts" setup>
const props = defineProps<{
  path: string;
  label?: string;
}>();

const route = useRoute();
const { gtag } = useGtag();

const sheetOpen = ref(false);

const openHelp = () => {
  gtag('event', 'help_button_click', { page_path: getMatchedRoutePath(route) });
  sheetOpen.value = true;
};
</script>

<template>
  <m-btn
    class="help-button"
    color="primary"
    variant="text"
    prepend-icon="mdi-help-circle-outline"
    @click="openHelp"
  >
    {{ props.label ?? $t('common.help') }}
  </m-btn>

  <right-sheet
    v-model="sheetOpen"
    width="min(960px, 92%)"
  >
    <docs-embedded-view
      :path="props.path"
      @close="sheetOpen = false"
    />
  </right-sheet>
</template>
